/**
 * @file  HelpTerms/index.tsx
 * @description  general content page - simple html page to show help content. This changes with branding
 * keep it simple AS THIS CHANGES OFTEN
 *
 * @author dlima (dlima-electron)
 *
 */
import React from 'react';
import ModalFluid from '../../elements/ModalFluid';
import { ContentLoader } from './content';
import './styles.scss';

/**
 * visibility props for the modal
 */
interface Props {
  visible: boolean;
  onCancel: () => void;
}

/**
 * display the general help modal with a fluid modal
 * @param props
 * @returns modal dialog
 */
const content = ({ visible, onCancel }: Props): JSX.Element => {
  return (
    <ModalFluid className="modal-fluid" visible={visible} onCancel={onCancel}>
      <ContentLoader onCancel={onCancel} />
    </ModalFluid>
  );
};

export default content;
